class RestockDate extends HTMLElement {
  connectedCallback() {
    const inputDate = this.getAttribute("data-date");
    const originalHTML = this.innerHTML;

    if (!inputDate) return;

    const formattedDate = this.formatDateLogic(inputDate);

    if (formattedDate) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = originalHTML;

      const formattedDateElement = tempDiv.querySelector(".formatted-date");
      if (formattedDateElement) {
        formattedDateElement.textContent = formattedDate;
      }

      this.innerHTML = tempDiv.innerHTML;
    }
  }

  formatDateLogic(inputDate) {
    if (!inputDate || inputDate.trim() === "") return "";

    const paddedDate = inputDate.padStart(8, "0");

    if (!/^\d{8}$/.test(paddedDate)) return "";

    const day = parseInt(paddedDate.substring(0, 2));
    const month = parseInt(paddedDate.substring(2, 4));
    const year = parseInt(paddedDate.substring(4, 8));

    if (month < 1 || month > 12 || day < 1 || day > 31 || year < 2000)
      return "";

    const inputDateObj = new Date(year, month - 1, day);
    const currentDate = new Date();

    currentDate.setHours(0, 0, 0, 0);
    inputDateObj.setHours(0, 0, 0, 0);

    const resultDate =
      inputDateObj <= currentDate
        ? new Date(currentDate.setDate(currentDate.getDate() + 3))
        : inputDateObj;

    const resultMonth = (resultDate.getMonth() + 1).toString().padStart(2, "0");
    const resultDay = resultDate.getDate().toString().padStart(2, "0");
    const resultYear = resultDate.getFullYear();

    return `${resultMonth}/${resultDay}/${resultYear}`;
  }
}

customElements.define("restock-date", RestockDate);


